import { render, staticRenderFns } from "./TerminosYCondicionesView.vue?vue&type=template&id=5e213d98&scoped=true&"
import script from "./TerminosYCondicionesView.vue?vue&type=script&lang=ts&"
export * from "./TerminosYCondicionesView.vue?vue&type=script&lang=ts&"
import style0 from "./TerminosYCondicionesView.vue?vue&type=style&index=0&id=5e213d98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e213d98",
  null
  
)

export default component.exports